import { Component, OnInit, Renderer2, ViewChild, ElementRef } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { AbstractBuyerComponent } from "./abstract/buyer.component";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "../entity/User";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { HeaderComponent } from "./incs/header.component";

@Component({
    selector: "kilowant-our-story",
    templateUrl: "../../html/main-our-story.html",
    imports: [HeaderComponent]
})
export class OurStoryComponent extends AbstractComponent {
    user: User | null = null;
    ourTeamOpened: boolean = false;    

    constructor(
        router: Router,
        route: ActivatedRoute,
        private authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, analyticsService, generalService); }

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.initPromises.push(this.loadUser());
        }
        super.ngOnInit();
    }

    loadUser(): Promise<User> {
        return this.generalService.getDetails()
            .then(u => {
                if (u == null) {
                    this.user = null;
                } else {
                    this.user = Object.assign(new User(), u);
                }
                return u;
            });
    }

    getBaseLink() {
        return this.router.url.split('#')[0];
    }

    mailing(): void {
        window.location.href = 'mailto:info@kilowant.com?subject=Kilowant Contact';
    }

    ourTeamOpen(): void {
        this.ourTeamOpened = !this.ourTeamOpened;
        if (this.ourTeamOpened) {
            this.analyticsService.trackEvent("open_view", { label: "our_team" });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
